import React from 'react'
import Icon from '../icon'
import {
  Alert,
  Text,
  ContainerIcon,
  Wrapper,
  Title,
  Cta,
  ContainerTitle,
  ContainerContent,
  ContainerClose,
  NewTag,
  ContainerNewsShort,
  ContainerCta,
} from './styles'
import Button from '../button'

type Props = {
  'data-qa'?: string
  children?: any
  text?: string
  title?: string
  ctaLink?: string
  ctaText?: string
  onClose?: Function
  onClick?: Function
  theme?: 'info' | 'negative' | 'alert' | 'neutral' | 'newsShort'
  infoText?: string
  hasIcon?: boolean
}

const Callout: React.FC<Props> = (props: Props): JSX.Element => {
  const dataQa = props['data-qa'] || `callout-${props.theme}`
  const isNewsShort = props.theme === 'newsShort'

  function renderContent(): JSX.Element {
    return (
      <>
        <ContainerContent
          className={`${props.theme} ${props.hasIcon ? 'has-icon' : ''}`}
        >
          <Text className={props.theme} data-qa={`${dataQa}-text`}>
            <p>{props.children ?? props.text}</p>
          </Text>
          {!isNewsShort && props.ctaLink && props.ctaText && (
            <ContainerCta>
              <Cta href={props.ctaLink} target="_blank">
                {props.ctaText}
              </Cta>
            </ContainerCta>
          )}
        </ContainerContent>
      </>
    )
  }

  return (
    <Wrapper>
      <Alert className={props.theme} data-qa={dataQa}>
        {isNewsShort ? (
          <ContainerNewsShort>
            <NewTag onClick={() => props.onClose()}>{'Novo'}</NewTag>
            {props.title && <Title>{props.title}</Title>}
            {renderContent()}
            <Button theme="secondary" onClick={() => props.onClick()}>
              {props.infoText}
            </Button>
            {props.onClose && (
              <ContainerClose onClick={() => props.onClose()}>
                <Icon name={'close'} />
              </ContainerClose>
            )}
          </ContainerNewsShort>
        ) : (
          <>
            <ContainerTitle>
              {props.hasIcon && (
                <ContainerIcon>
                  <Icon
                    name={variantIconName[props.theme]}
                    color={variantIcon[props.theme]}
                    data-qa={`${dataQa}-icon`}
                  />
                </ContainerIcon>
              )}
              {props.title && <Title>{props.title}</Title>}
              {props.onClose && props.hasIcon && (
                <ContainerClose onClick={() => props.onClose()}>
                  <Icon name={'close'} />
                </ContainerClose>
              )}
            </ContainerTitle>
            {renderContent()}
          </>
        )}
      </Alert>
    </Wrapper>
  )
}

Callout.defaultProps = {
  theme: 'neutral',
  infoText: 'Saiba mais',
}

export default Callout

const variantIcon = {
  info: 'feedbackColorInfoPure',
  negative: 'feedbackColorNegativePure',
  alert: 'feedbackColorWarningDark',
  neutral: 'gray600',
}

const variantIconName = {
  info: 'info_outlined',
  negative: 'info_outlined',
  alert: 'warning_outlined',
  neutral: 'info_outlined',
}
